/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import {
    getBackgroundImg,
    getUploadedImagePath,
    MarkupRender,
    useAppDispatch,
    useAppState
} from '@nutastic/nutastic-react-app';
import { useParams } from 'react-router-dom';
import { useNavigation } from '../../hooks/useNavigation';
import { WebsiteActions } from '../../state/actions.mjs';
import classnames from 'classnames';
import Footer from '../Footer';
import ContentNotFoundPage from "./ContentNotFoundPage";
import Href from "../Href";

const componentClass = 'newsPage';

const ContentNewsPage = () => {
    const appDispatch = useAppDispatch();
    const {
        isProcessing,
        content: {
            news = []
        }
    } = useAppState();
    const { id: newSlug } = useParams();
    const { loadPage } = useNavigation();
    const [ currentArticle, setCurrentArticle ] = useState(null);

    const classes = classnames( componentClass, 'animated', 'fadeIn' );

    const {
        title,
        content,
        image,
        image_1: banner,
        subtitle,
        button1,
        button2
    } = currentArticle || {};

    const renderButton = (buttonObject, buttonClasses) => {
        if(buttonObject && buttonObject.hasOwnProperty('url') && buttonObject.url) {
            const {url, urlType, text} = buttonObject;
            if (urlType === 'external') {
                return <a className={buttonClasses} href={url} target="_blank">{ text }</a>;
            } else {
                return <Href className={buttonClasses} url={url}>{ text }</Href>;
            }
        }
        return null;
    };

    useEffect(() => {
        appDispatch({ type: WebsiteActions.REUP_STARTED });
        setCurrentArticle(null);
        const matchedArticle = news.find(a => a?.slug === newSlug);
        if (matchedArticle) {
            setCurrentArticle(matchedArticle);
        }
        setTimeout(() => {
            appDispatch({ type: WebsiteActions.REUP_DONE });
        }, 1000);
    }, [newSlug])

    return (!isProcessing && !!currentArticle) ? <React.Fragment>
        <article className={classes}>
            <div className={`${componentClass}__header`}>
                { banner && <div className={`${componentClass}__banner`} style={getBackgroundImg(getUploadedImagePath(banner))} /> }
                <img src={getUploadedImagePath(image)} alt={`${title} :: QuistarGo.com`} className={`${componentClass}__pageImage`} />
                <div className={`${componentClass}__headerInfo`}>
                    <h1>{ title }</h1>
                    { subtitle && <p>{ subtitle }</p> }
                </div>
            </div>
            <div className="container">
                <MarkupRender className={`${componentClass}__content`} tagName={'div'} content={content}/>
                <div className={`${componentClass}__buttons`}>
                    { renderButton(button1, 'btn btn-white') }
                    { renderButton(button2, 'btn btn-outline-white') }
                </div>
            </div>
        </article>
        <Footer useReducedPadding={true} />
    </React.Fragment> : <ContentNotFoundPage isProcessing={isProcessing} />;
};

export default ContentNewsPage;
